import React, {useMemo} from "react";
import {Col, Row} from "antd";
import {AnnouncementRow} from "./announcementRow/AnnouncementRow";
import {OrderStats} from "./orderStats/OrderStats";
import {DeliveryListBlock} from "./deliveryListBlock/DeliveryListBlock";
import {observer} from "mobx-react-lite";
import {CustomerFluidSubPageLayout} from "components/layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";
import CustomerHomePageWithShiftScore from "../customerHomePageWithShiftScore/CustomerHomePageWithShiftScore";

const CustomerHomePage = observer(() => {
    const stores = useStore();
    const isPoolCompany = stores?.meStore?.isPoolCustomer;
    const selectedSubCompanyId = stores?.meStore?.selectedSubCompanyId;
    const company = stores?.meStore?.companies?.[0]?._id;
    const companies = stores?.meStore?.selectedCompanies;
    const city = stores?.meStore?.selectedCity;

    const [subCompaniesLoading, subCompanies] = useFetch({
        fetchFn: stores.companyStore.getSubCompanyList.bind(null, {
            companyId: company,
            companies: companies?.join(".") || "",
            limit: 1000,
            city: !city || city === "all" ? undefined : city
        }),
        dependencies: [company, companies, city],
        initialCall: true
    });

    const selectedSubCompany = useMemo(() => {
        if (
            !subCompanies ||
            !subCompanies.rows ||
            !Array.isArray(subCompanies.rows) ||
            !selectedSubCompanyId
        ) {
            return null;
        }

        const found = subCompanies.rows.find(subCompany => subCompany._id === selectedSubCompanyId);
        return found;
    }, [subCompanies, selectedSubCompanyId]);

    const activeIntegrationUrls = selectedSubCompany?.activeIntegrationUrls || [];
    return (
        <CustomerFluidSubPageLayout>
            <CustomerMenuHeader />
            <Row style={{width: "100%", padding: "0"}}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <AnnouncementRow />
                </Col>
            </Row>
            {isPoolCompany ? (
                <>
                    <Row style={{width: "100%", marginTop: "12px", padding: "0"}}>
                        <Col xs={24}>
                            <OrderStats />
                        </Col>
                    </Row>

                    <Row style={{width: "100%", marginTop: "40px", marginBottom: "80px"}}>
                        <Col xs={24}>
                            <DeliveryListBlock activeIntegrationUrls={activeIntegrationUrls} />
                        </Col>
                    </Row>
                </>
            ) : (
                <CustomerHomePageWithShiftScore />
            )}
        </CustomerFluidSubPageLayout>
    );
});

export default CustomerHomePage;
